import React, { useState } from 'react'
import OpenGameModal from '../../containers/open-game-modal'
import OpenGameForm from '../open-game-form'
import FacilityModal from './facility-modal'
import ReconcileModal from './reconcile-modal'

function Table({reconciliations, order, socketUrl, onOrder, onCloseGame, onUpdateGame, onRefreshGame, onUpdateFacilityPay, onLocationUpdate}) {
  const [showGameModal, setShowGameModal] = useState(null)
  const [showGameForm, setShowGameForm] = useState(null)
  const [showFacilityModal, setShowFacilityModal] = useState(null)
  const [showReconcileModal, setShowReconcileModal] = useState(null)

  const oppositeSort = (sortOrder) => {
    return (sortOrder == 'asc') ? 'desc' : 'asc'
  }

  const onClickHeader = (name) => {
    const currentSort = Object.keys(order)[0]
    const currentSortOrder = order[currentSort]

    const newSortOrder = (currentSort == name) ? oppositeSort(currentSortOrder) : 'asc'
    onOrder({[name]: newSortOrder})
  }

  const column = (title, name) => {
    const currentSort = Object.keys(order)[0]
    const className = (name == currentSort) ? order[currentSort] : ''

    return <th className={className} onClick={() => onClickHeader(name)}>{title}</th>
  }

  const cell = (reconciliation, name, isPrice = false, isQuantitative = false) => {
    const value = reconciliation[name]
    const showAmount = value != null && isPrice
    var classNames = [name]
    if (showAmount) classNames.push('amount-data')
    if (isQuantitative) classNames.push('quantitative')
    return <td className={classNames.join(' ')}>{showAmount ? price(value) : value}</td>
  }

  const price = (value) => {
    return parseFloat(value).toFixed(2)
  }

  const preview = (reconciliation, name) => {
    const value = reconciliation[name]
    if (!value) return ''
    if (value.length < 16) return value

    return `${value.slice(0, 15).trim()}...`
  }

  const closeGameModal = () => {
    onCloseGame()
    setShowGameModal(null)
  }

  const updateGame = (data) => {
    onUpdateGame(data)
    onRefreshGame(data)
    setShowGameForm(null)
  }

  return <div className='reconciliations-table'>
    { showGameModal &&
      <OpenGameModal
        activeTab='game-details'
        gameId={showGameModal}
        socketUrl={socketUrl}
        onClose={closeGameModal}
        onDuplicate={() => {}}
        onEdit={() => setShowGameForm(showGameModal)}
        onCancel={closeGameModal}
      /> 
    }
    { showGameForm &&
      <OpenGameForm
        type={'edit'}
        id={showGameForm}
        onClose={() => setShowGameForm(null)}
        onUpdate={updateGame}
      /> 
    }
    <table>
      <thead>
        <tr>
          {column('Event Name', 'name')}
          {column('Date', 'date_with_time')}
          {column('Facility', 'location_name')}
          {column('Region', 'region_name')}
          {column('Game Size', 'game_size')}
          {column('Players', 'players_count')}
          {column('Game Price', 'game_price')}
          {column('Revenue', 'revenue')}
          {column('Received', 'received')}
          {column('Unpaid', 'revenue - received')}
          {column('Payment Type', 'location_payment_type')}
          {column('Facility Commission Notes', 'commission_notes')}
          {column('Facility Commission', 'facility_cost')}
          {column('Plei Net', 'revenue - facility_cost')}
          {column('Plei Paid', 'facility_pay_payment_type')}
          {column('How Did We Pay?', 'facility_pay_payment_type')}
          {column('When Did We Pay?', 'facility_pay_paid_at')}
          <th>Notes</th>
          {column('Captain Pay', 'captain_paid_amount')}
          {column('Captain - How Did We Pay?', 'captain_payment_type')}
          {column('Captain - When Did We Pay?', 'captain_paid_at')}
          <th>Captain Notes</th>
          <th>Reconciliation</th>
        </tr>
      </thead>
      <tbody>
        {reconciliations.map((reconciliation, index) =>
          <tr key={index}>
            <td className='event-name'>
              <div title={reconciliation.event_name} onClick={() => setShowGameModal(reconciliation.id)}>
                {reconciliation.event_name}
              </div>
            </td>
            {cell(reconciliation, 'event_time')}
            <td className='facility' onClick={() => setShowFacilityModal({id: reconciliation.location_id})}>
              {reconciliation['facility']}
            </td>
            {cell(reconciliation, 'region')}
            {cell(reconciliation, 'game_size')}
            {cell(reconciliation, 'players', false, true)}
            {cell(reconciliation, 'game_price', true)}
            {cell(reconciliation, 'revenue', true, true)}
            {cell(reconciliation, 'received', true, true)}
            {cell(reconciliation, 'unpaid', true, true)}
            {cell(reconciliation, 'payment_type')}
            <td title={reconciliation.commission_notes} className='commission_notes'>
              {preview(reconciliation, 'commission_notes')}
            </td>
            {cell(reconciliation, 'facility_commission', true, true)}
            {cell(reconciliation, 'plei_net', true, true)}
            {cell(reconciliation, 'plei_paid', true, true)}
            {cell(reconciliation, 'how_paid')}
            <td className='when_paid'>
              {reconciliation.when_paid && moment(reconciliation.when_paid).format('MM/DD/YYYY') || ''}
            </td>
            <td title={reconciliation.notes} className='notes'>{preview(reconciliation, 'notes')}</td>
            {cell(reconciliation, 'captain_paid', true, true)}
            {cell(reconciliation, 'captain_how_paid')}
            <td className='captain_when_paid'>
              {reconciliation.captain_when_paid && moment(reconciliation.captain_when_paid).format('MM/DD/YYYY') || ''}
            </td>
            <td title={reconciliation.captain_notes} className='captain_notes'>{preview(reconciliation, 'captain_notes')}</td>
            <td className='reconciliation'>
              <button className='btn btn-primary reconcile' onClick={() => setShowReconcileModal({id: reconciliation.id})}>
                { reconciliation.facility_pay_id ? 'Edit' : 'Reconcile' }
              </button>
            </td>
          </tr>
        )}
      </tbody>
    </table>
    { showReconcileModal &&
      <ReconcileModal
        onClose={() => setShowReconcileModal(null)}
        onUpdateFacilityPay={onUpdateFacilityPay}
        gameId={showReconcileModal.id} />
    }
    { showFacilityModal &&
      <FacilityModal
        onClose={() => setShowFacilityModal(null)}
        locationId={showFacilityModal.id}
        onLocationUpdate={onLocationUpdate}
      />
    }
  </div>
}

export default Table
